import PropTypes from 'prop-types';

const propType = {
  discount: PropTypes.number,
  shippingTotal: PropTypes.number,
  shippingTax: PropTypes.number,
  subtotal: PropTypes.number,
  tax: PropTypes.number,
  total: PropTypes.number,
  userDiscount: PropTypes.number,
  userDiscountPercentage: PropTypes.number,
  totalVA: PropTypes.number,
  totalCV: PropTypes.number,
};

const defaultProp = {
  discount: 0,
  shippingTotal: 0,
  shippingTax: 0,
  subtotal: 0,
  tax: 0,
  total: 0,
  userDiscount: 0,
  userDiscountPercentage: 0,
  totalVA: 0,
  totalCV: 0,
};

export default { propType, defaultProp };
